import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

// بانر رأس الصفحة — يبقى مثبَّتاً بفضل تخطيط الأب Flex، لا يتحرك مع تمرير المحتوى.
export const DetailHeader = ({ number, backTo }) => {
  const { t, i18n } = useTranslation();
  const nav = useNavigate();
  const Chevron = i18n.language === "ar" ? ChevronLeft : ChevronRight;
  return (
    <header dir="rtl"
      className="flex shrink-0 items-center justify-between gap-3 bg-slate-800 px-4 py-4 text-white shadow-lg sm:px-8 lg:px-12"
      style={{ paddingTop: "max(1rem, env(safe-area-inset-top))" }}
      data-testid="po-detail-header">
      <div>
        <p className="text-lg font-extrabold sm:text-xl">{t("purchases.podetail.title")}</p>
        <p className="mt-0.5 num font-mono text-[11px] opacity-80" data-testid="po-detail-number">
          {number || t("purchases.noNumber")}
        </p>
      </div>
      <button data-testid="po-detail-back"
              onClick={() => (backTo ? nav(backTo) : nav(-1))}
              className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20">
        <Chevron className="h-5 w-5" />
      </button>
    </header>
  );
};
